const state = {
  list: [],
  rejectedlist: [],
  isLoading: false,
  isTransporterLoading: false,
  filter: {},
  hasEmpty: false,
  isPaginating: false,
  rejectionFilter: {},
};

export default state;
